import Vue from 'vue'
import Router from 'vue-router'

import Layout from '@/Layout'

Vue.use(Router)

const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home')
      },
      {
        path: 'services',
        name: 'services',
        component: () => import('@/views/services')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/about')
      },
      {
        path: 'blog',
        name: 'blog',
        component: () => import('@/views/blog')
      },
      {
        path: 'faq',
        name: 'faq',
        component: () => import('@/views/faq')
      },
      {
        path: 'policy',
        name: 'policy',
        component: () => import('@/views/policy')
      },
      {
        path: 'terms',
        name: 'terms',
        component: () => import('@/views/term')
      },
      {
        path: 'forget',
        name: 'forget',
        component: () => import('@/views/forget')
      },
      {
        path: 'reset',
        name: 'reset',
        component: () => import('@/views/reset')
      },
      {
        path: 'blogedit',
        name: 'blogedit',
        component: () => import('@/views/BlogEdit')
      }
    ]
  },
  {
    path: '/sample-inspection-report',
    component: () => import('@/views/sample-report'),
    name: 'sample-inspection-report'
  }
]

const router = new Router({
  // base: '/dist',
  // mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.path === '/services' && to.query.id) {
      console.log(to.query.id)
      return
    }
    return { y: 0 }
  },
  routes: constantRoutes
})

router.beforeEach((to, from, next) => {
  console.log('beforeEach')
  next()
})

router.afterEach((to, from) => {
  console.log('afterEach')
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js